import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/lib/theme";

export default function DarkModeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label="Toggle theme"
      className={`w-10 h-10 rounded-full glass flex items-center justify-center hover:scale-110 transition-transform ${className}`}
    >
      {theme === "dark" ? (
        <Sun className="w-4 h-4 text-yellow-400" strokeWidth={1.8} />
      ) : (
        <Moon className="w-4 h-4 text-indigo-600" strokeWidth={1.8} />
      )}
    </button>
  );
}
